import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Loader from '../../utils/Loader';
import Config from '../../config/Config';
import {
	startAttempt,
	toggleMicPermission,
} from '../../redux/testPage/testPage.actions';
import { fetchInstruction } from '../../redux/myCourse/myCourse.actions';
import {
	getChildCourse,
	getProductDetails,
	getChildSpeechCourse,
	getChildReport,
	applyLicense,
} from '../../redux/parentDashboard/parentDashboard.actions';
import { openPopupWidget } from 'react-calendly';
import { changeActiveCourse } from '../../redux/changeCourse/changeCourse.actions';
import {
	setErrorMsg,
	setShowPermitMic,
} from '../../redux/utilities/utils.actions';
import {
	getCoachCallTime,
	daysBeforeCall,
	minToMs,
} from '../../utils/commonFunctions';

const SpeechTest = ({
	getChildCourse,
	match,
	history,
	childrenList,
	getProductDetails,
	productDetail,
	changeActiveCourse,
	userPhone,
	userEmail,
	call_time,
	meeting_id,
	calendly_url,
	call_status,
	cert_url_speech,
	score_speech,
	applyLicense,
}) => {
	const {
		product_id,
		child_id,
		course_id,
		child_name,
		product_course_id,
		child_grade,
	} = childrenList[match.params.id || 0] || [];

	const pageSettings = {
		backgroundColor: 'ffffff',
		hideEventTypeDetails: false,
		hideLandingPageDetails: false,
		primaryColor: '00a2ff',
		textColor: '4d5055',
	};
	const [prefill, setPrefill] = useState({});
	const [utm, setUtm] = useState({});
	const [url, setUrl] = useState('');
	const [enableJoin, setEnableJoin] = useState(false);

	useEffect(() => {
		Loader.hide();
		if (!!course_id) {
			getChildCourse(course_id);
			getProductDetails(match.params.id || 0);
			changeActiveCourse(course_id);
		}
	}, [
		course_id,
		getChildCourse,
		getProductDetails,
		changeActiveCourse,
		match.params.id,
	]);
	//watch for meeting time
	useEffect(() => {
		let timer;
		if (
			!!call_time &&
			daysBeforeCall(call_time) < minToMs(60) &&
			daysBeforeCall(call_time) > minToMs(5)
		) {
			timer = setInterval(function () {
				if (daysBeforeCall(call_time) <= minToMs(5)) {
					setEnableJoin(true);
					clearInterval(timer);
				}
			}, 10000);
		}
		return () => {
			if (!!timer) {
				clearInterval(timer);
			}
		};
	}, [call_time]);

	//watch for meeting time
	useEffect(() => {
		let timer;
		if (
			!!call_time &&
			daysBeforeCall(call_time) < minToMs(60) &&
			daysBeforeCall(call_time) > minToMs(5)
		) {
			timer = setInterval(function () {
				if (daysBeforeCall(call_time) <= minToMs(5)) {
					setEnableJoin(true);
					clearInterval(timer);
				}
			}, 10000);
		}
		return () => {
			if (!!timer) {
				clearInterval(timer);
			}
		};
	}, [call_time]);

	//calendly details
	useEffect(() => {
		setPrefill({
			email: userEmail,
			name: child_name,
			customAnswers: {
				a1: `91${userPhone || ''}`,
			},
		});

		setUtm({
			utmCampaign: parseInt(child_id, 10),
			utmSource: parseInt(product_course_id, 10),
			utmMedium: match.params.id || 0,
			name: child_name,
			email: userEmail,
			a1: userPhone,
		});

		setUrl(calendly_url);
	}, [
		calendly_url,
		setPrefill,
		setUtm,
		setUrl,
		userEmail,
		child_name,
		userPhone,
		child_id,
		product_course_id,
		match.params.id,
	]);

	return (
		<>
			{productDetail && (
				<div className="dash-courses last-dash-course">
					<div className="dash-course-logo">
						<img
							src={`${Config.ASSETSPATH}img/STEPATHON_Junior_Plus.jpg`}
							alt="courseimage"
						/>
					</div>
					<div className="dash-course-decs">
						<div className="d-flex flex-row align-items-center justify-content-between">
							<div className="flex-grow-1">
								<p>Speaking Test</p>
								{/* Description logic  */}
								{call_status?.toLowerCase() === 'completed' ? (
									<>
										<p className="dash-decs-date">
											<strong> You have completed the test!</strong>{' '}
										</p>
										<small>Your report is ready to download.</small>{' '}
									</>
								) : !!call_time ? (
									<>
										<p className="dash-decs-date">
											<strong>
												Your testing slot is booked at {getCoachCallTime(call_time)}
											</strong>
										</p>
										<small>You can join the call 5 mins before the scheduled time</small>{' '}
									</>
								) : !productDetail.is_purchased ? (
									<>
										<p className="dash-decs-date">
											<strong>You haven't bought this course</strong>
										</p>
									</>
								) : (
									<>
										<p className="dash-decs-date">
											<strong>You can attempt the Speaking Test only once.</strong>
										</p>
										<small>Reserve your 30-minute testing slot now!</small>{' '}
									</>
								)}
							</div>
							{/* button logics */}
							<div>
								{call_status?.toLowerCase() === 'completed' ? (
									<span className="d-flex flex-row align-items-center">
										<div
											className="kid-score-icon"
											target="_blank"
											rel="noopener noreferrer"
										>
											<span>{score_speech || 0}%</span>
										</div>
										<a
											href={cert_url_speech}
											target="_blank"
											rel="noopener noreferrer"
											className="kids-certificate"
										>
											<img src="/assets/img/chart-download-icon.svg" alt="Speech score" />
										</a>
									</span>
								) : !!call_time ? (
									daysBeforeCall(call_time) > minToMs(5) && !enableJoin ? (
										<button
											aria-label="Book a Call"
											className="btn btn-primary step-btn disabled"
											style={{ pointerEvents: 'none' }}
										>
											Join Call
										</button>
									) : (
										<a
											target="_blank"
											rel="noopener noreferrer"
											href={`https://payment.steptest.in/kids/user.php?mid=${meeting_id}&mname=Kids%20Speaking%20Program%20-${child_grade}&uname=${child_name}&childIndex=${
												match.params.id || 0
											}`}
										>
											<button
												//	onClick={() => openPopupWidget({ url, prefill, pageSettings, utm })}
												aria-label="Book a Call"
												className="btn btn-primary step-btn"
											>
												Join Call
											</button>
										</a>
									)
								) : productDetail.is_purchased ? (
									<button
										onClick={() => openPopupWidget({ url, prefill, pageSettings, utm })}
										aria-label="Book a Call"
										className="btn btn-primary step-btn"
									>
										View Slots
									</button>
								) : localStorage.getItem('juniorAccount') !== 'true' &&
								  productDetail.is_parentpurchased ? (
									<button
										onClick={applyLicense}
										aria-label="Purchase Course"
										className="btn btn-primary step-btn"
									>
										Apply License
									</button>
								) : (
									<button
										onClick={() =>
											history.push(`/purchase?productID=${product_id}&childId=${child_id}`)
										}
										aria-label="Purchase Course"
										className="btn btn-primary step-btn"
									>
										Buy Course
									</button>
								)}
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

const mapStateToProps = (state) => {
	const {
		courses,
		childrenList,
		childToken,
		productDetail,
		coachDetails,
		call_time,
		completed_calls,
		meeting_id,
		total_calls,
		calendly_url,
		call_status,
		score_speech,
		cert_url_speech,
	} = state.rootReducer.parentDetails;
	const { userPhone, userEmail } = state.rootReducer.loginDetails;
	return {
		courses,
		childrenList,
		childToken,
		productDetail,
		userPhone,
		userEmail,
		coachDetails,
		call_time,
		completed_calls,
		meeting_id,
		total_calls,
		calendly_url,
		call_status,
		score_speech,
		cert_url_speech,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchInstruction: (elementId, courseId, completed = false, childToken) =>
			dispatch(fetchInstruction({ elementId, courseId, completed, childToken })),
		toggleMicPermission: (val) => dispatch(toggleMicPermission(val)),
		setErrorMsg: (msg) => dispatch(setErrorMsg(msg)),
		startAttempt: (courseId, elementId) =>
			dispatch(startAttempt({ courseId, elementId })),
		setShowPermitMic: (val) => dispatch(setShowPermitMic(val)),
		getChildCourse: (val) => dispatch(getChildCourse(val)),
		getProductDetails: (val) => dispatch(getProductDetails(val)),
		changeActiveCourse: (id) => dispatch(changeActiveCourse(id)),

		getChildSpeechCourse: (id) => dispatch(getChildSpeechCourse(id)),
		getChildReport: () => dispatch(getChildReport()),
		applyLicense: () => dispatch(applyLicense()),
	};
};

export default withRouter(
	compose(connect(mapStateToProps, mapDispatchToProps))(SpeechTest),
);
